exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fmcy-product-zoom-toggle {\n  background-color: #fff;\n  border: 2px solid #CCCCCC;\n  border-radius: 23px;\n  padding: 5px 10px;\n  font-size: 1em;\n  font-weight: 600; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/menu/menu-item-expanded/product-zoom-toggle/product-zoom-toggle.scss
 ** module id = 785
 ** module chunks = 1 81 172
 **/